module.exports = __webpack_public_path__ + "static/img/image_tabar_sub@3x.06903a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/image_tabar_sub@3x.png
// module id = 255
// module chunks = 18